import { useGetRegexes } from "./services";

const cleanReadRE = /^[^;?\n]+/ //keep text before special caracter
const validHost = /(?<host>pando.ovh)(?<pathname>\/[^\s]*)?/i
const qwertyHost = /pqndo\/ovh/i


export default function useAnalyzeScan () {
  const regexes = useGetRegexes();
  return (input = '') => {
    const text = input.match(cleanReadRE)?.at(0) || '';
    const pandoURLScan = analyzePandoURL(text);
    if (pandoURLScan.pathname){
      return {...pandoURLScan, input};
    }
    if (qwertyHost.test(text)) {
      const azertyText = input.split('')
        .map(c => qwertyToAzerty[c] || c).join('');
      return {...analyzePandoURL(azertyText), input};
    } 
    for (const regex of regexes) {
      const bacId = text.match(regex)?.groups?.id;
      if (bacId) {
        return {bacId, input};
      }
    }
    return {error: `${input} doesn't contain a valid code.`, input};
  };
}


/* Analyzes a string to see if it is a pando url. */
const analyzePandoURL = text => {
  const { host, pathname } = text?.match(validHost)?.groups || {};
  const { urlId } = pathname?.match(/\/bacs\/(?<urlId>[^\s]*)/i)?.groups || {};
  const { formatedId }=urlId?.match(/(?<formatedId>[A-Z]\d{6})/i)?.groups || {};
  if (!host) {
    return { error: `${text} doesn't contain pando.ovh url.` };
  } else if (!urlId){
    return { error: `${pathname} is not a bac URL.`, pathname };
  } else if (!formatedId) {
    return { error: `${urlId} wrong format (1 letter + 6 digits).`, pathname };
  }
  return { bacId: formatedId, pathname };
}

const qwertyToAzerty = {
    'a': 'q', 'z': 'w', 'q': 'a', 'w': 'z', 
    'm': ',', ',': 'm', ';': 'm', ':': 'M',
    'A': 'Q', 'Z': 'W', 'Q': 'A', 'W': 'Z',
    '/':'.', '§':'/', 'm':':', 
};
